import { createFileRoute } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { organizationQueries } from '@/features/organizations/queries';
import { billingAddressQueries } from '@/features/billing-addresses/queries';
import { BillingPage } from '@/features/billing-addresses/pages/BillingPage';
import { DetailsPageSkeleton } from '@/common/components/loading-skeleton/DetailsPageSkeleton';

export const Route = createFileRoute('/_authenticated/billing')({
  component: BillingPage,
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([
      queryClient.ensureQueryData(organizationQueries.list()),
      queryClient.ensureQueryData(organizationQueries.membersList()),
      queryClient.ensureQueryData(billingAddressQueries.list()),
    ]);
    return { breadcrumb: t`Billing` };
  },
  pendingComponent: DetailsPageSkeleton,
});
